import * as z from "../../../framework";
import { Dictionary } from "lodash";
import { churnZeroInitialized, stopChurnZero } from "./churnZero";
import { events } from "../../../framework/core/core";

export enum ChurnZeroEvents {
    userLoggedInToServicePro = "userLoggedInToServicePro",
    churnZeroInitialized = "churnZeroInitialized",
    churnZeroStopped = "churnZeroStopped"
};

type ChurnZeroEventName = keyof typeof ChurnZeroEvents;

interface EventArgs {
    description?: string;
    quantity?: number;
    customFields?: Dictionary<string>;
}

type ChurnZeroEventData = {
    eventName: ChurnZeroEventName;
    args: EventArgs;
};
type ChurnZeroEventQueue = ChurnZeroEventData[];

const eventQueue: ChurnZeroEventQueue = [];

export function trackEvent(eventName: ChurnZeroEventName, args?: EventArgs, isLogin?: boolean) {
    const newEvent = { eventName, args };
    let enableMSIChurnZeroEvents = false;
    let worksAtMsi = false;

    // Check if it is the login event since the z.user information is not set when that event is fired
    if (isLogin) {
        if (localStorage.companyData !== undefined && localStorage.companyData !== null) {
            let companyData = $.parseJSON(localStorage.companyData);
            if (companyData !== undefined && companyData !== null) {
                const enableMSIChurnZeroEventsOption = companyData.Options.find(o => o.OptionNumber === "EnableMSIChurnZeroEvents")?.Value.toLowerCase();
                if (enableMSIChurnZeroEventsOption !== null && enableMSIChurnZeroEventsOption !== undefined) {
                    enableMSIChurnZeroEvents = enableMSIChurnZeroEventsOption === "true";
                }
            }
        }
        if (localStorage.authProfile !== undefined && localStorage.authProfile !== null) {
            let authProfile = $.parseJSON(localStorage.authProfile);
            if (authProfile !== undefined && authProfile !== null) {
                worksAtMsi = Boolean(authProfile.email.endsWith("@msidata.com"));
            }
        }
    } else {
        enableMSIChurnZeroEvents = z.util.getBooleanOption("EnableMSIChurnZeroEvents", false);
        worksAtMsi = z.user.loginData.UserName.endsWith("@msidata.com");
    }

    // Push event if the User does not work at MSI or works at MSI with the option turned on
    const shouldPushEvent = !worksAtMsi || (enableMSIChurnZeroEvents && worksAtMsi);
    if (shouldPushEvent) {
        if (churnZeroInitialized) {
            pushEvent(newEvent);
        } else {
            eventQueue.push(newEvent); // we need to wait until ChurnZero is initialized to give it events, otherwise they won't register
        }
    }
}
events.register(ChurnZeroEvents.churnZeroInitialized, () => pushQueuedEvents(eventQueue));

function pushQueuedEvents(queue: ChurnZeroEventQueue): void {
    while(queue.length > 0) {
        const event = queue.shift();
        pushEvent(event);
    }
}

function pushEvent(event: ChurnZeroEventData) {
    window.ChurnZero.push([
        "trackEvent",
        event.eventName,
        event.args.description,
        event.args.quantity,
        event.args.customFields
    ]);
}

export function trackLogin(companyData: z.CompanyData) {
    trackEvent(ChurnZeroEvents.userLoggedInToServicePro, { description: `Logged in to tenant ${companyData.CompanyName}` }, true);
}